import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";
import {Tag} from "primereact/tag";
import appStore from "../../../storage/AppStore";
import {getBaseUrl} from "../../../common/config";
import Btn from "../../../ui/Btn";
import "../../../common/billing.css";

const BillingItem = ({period, url_base}) => {
    const navigate = useNavigate();

    const getStatus = (item) => {
        if (!item.is_paid) return {label: appStore.tr.unpaid, severity: "danger"};
        if (!item.is_approved) return {label: appStore.tr.awaiting_approval, severity: "warning"};
        return {label: appStore.tr.paid, severity: "success"};
    };

    return (
        <>
            <div className="col-12 mt-2 mb-1">
                <b>{appStore.tr[period.month] || period.month} {period.year}</b>
            </div>

            {(period.items || []).map((item) => {
                const status = getStatus(item);
                const cheques = item.cheques || [];
                const title = item.billing_group?.name || item.description || item.billing_type?.name || `#${item.id}`;

                return (
                    <div key={item.id} className="billing-card">
                        <div className="billing-top">
                            <div className="billing-main">
                                <div className="billing-title">{title}</div>

                                <div className="billing-sub">
                                    {item.billing_type?.name}
                                    {item.object?.name && item.object.name !== title && <span>, {item.object.name}</span>}
                                </div>

                                {item.notes && <div className="billing-notes">{item.notes}</div>}
                            </div>

                            <div className="billing-side">
                                <div className="billing-amount">
                                    {item.amount}{item.currency?.sign || ""}
                                </div>

                                <div className="billing-status">
                                    <Tag severity={status.severity} value={status.label}/>
                                    {item.is_paid && item.payment_method && (
                                        <Tag
                                            severity="info"
                                            className="ml-1"
                                            value={appStore.tr[item.payment_method] || item.payment_method}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="billing-actions">
                            {!item.is_paid ? (
                                <Btn
                                    icon="pi pi-dollar"
                                    label={appStore.tr.pay}
                                    severity="success"
                                    onClick={() => navigate(`${url_base}/pay/${item.id}`)}
                                />
                            ) : (
                                <Btn
                                    icon="pi pi-eye"
                                    label={appStore.tr.view}
                                    severity="secondary"
                                    outlined
                                    onClick={() => navigate(`${url_base}/pay/${item.id}`)}
                                />
                            )}

                            {item.payment_method === "transfer" && cheques.map((cheque, index) => (
                                <a
                                    key={cheque.file_id || index}
                                    href={`${getBaseUrl()}/manager/billing/cheque/${item.id}/${cheque.file_id}?jwt=${sessionStorage.getItem("jwt")}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="no-underline"
                                >
                                    <Btn
                                        icon={cheque.mimetype === "application/pdf" ? "pi pi-file-pdf" : "pi pi-image"}
                                        label={appStore.tr.cheque}
                                        size="small"
                                        outlined
                                    />
                                </a>
                            ))}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default observer(BillingItem);
